import React, { Component } from "react";

export default class StepThree extends Component {
  state = {
    interests: []
  };

  cardSelect = e => {
    var interests = this.state.interests;
    const allCards = document.querySelectorAll(".card-selector");
    let interest;

    if (e.target.parentElement.classList.contains("card-selector")) {
      if (e.target.parentElement.classList.contains("selected")) {
        e.target.parentElement.classList.remove("selected");
        for (let i = 0; i < interests.length; i++) {
          if (interests[i] == e.target.parentElement.id) {
            interests.splice(i, 1);
          }
        }
      } else {
        e.target.parentElement.classList.add("selected");
        interest = e.target.parentElement.id;
      }
    } else {

      if (e.target.classList.contains("selected")) {
        e.target.classList.remove("selected");
        for (let i = 0; i < interests.length; i++) {
          if (interests[i] == e.target.id) {
            interests.splice(i, 1);
          }
        }
      } else {
        e.target.classList.add("selected");
        interest = e.target.id;
      }
    }

    interests.push(interest);
    this.setState({ interests: interests });
    this.props.selectInterest(this.state.interests);
  };

  render() {
    return (
      <div className="step-item container">
        <div className="text-center">
          <h4 >A few of my interest include</h4>
          <p className="blockquote-footer">You can select more than one</p>
        </div>
        <div className="row d-flex">
          <div className="col-md-3 my-3">
            <div
              id="Food and Drinks"
              className="card card-selector card-body text-center"
              onClick={this.cardSelect}
            >
              <i class="fas fa-utensils"></i>
              <h6 className="m-0">Food and Drinks</h6>
            </div>
          </div>
          <div className="col-md-3 my-3">
            <div
              id="Music"
              className="card card-selector card-body text-center"
              onClick={this.cardSelect}
            >
              <i class="fa fa-music" />
              <h6 className="m-0">Music</h6>
            </div>
          </div>
          <div className="col-md-3 my-3">
            <div
              id="Sports"
              className="card card-selector card-body text-center"
              onClick={this.cardSelect}
            >
              <i class="far fa-futbol"></i>
              <h6 className="m-0">Sports</h6>
            </div>
          </div>
          <div className="col-md-3 my-3">
            <div
              id="Movies and TV"
              className="card card-selector card-body text-center"
              onClick={this.cardSelect}
            >
              <i class="fa fa-tv" />
              <h6 className="m-0">Movies and TV</h6>
            </div>
          </div>
          <div className="col-md-3 my-3">
            <div
              id="Travel"
              className="card card-selector card-body text-center"
              onClick={this.cardSelect}
            >
              <i class="fa fa-suitcase" />
              <h6 className="m-0">Travel</h6>
            </div>
          </div>
          <div className="col-md-3 my-3">
            <div
              id="Arts"
              className="card card-selector card-body text-center"
              onClick={this.cardSelect}
            >
              <i class="fa fa-paint-brush" />
              <h6 className="m-0">Arts</h6>
            </div>
          </div>
          <div className="col-md-3 my-3">
            <div
              id="Gaming"
              className="card card-selector card-body text-center"
              onClick={this.cardSelect}
            >
              <i class="fa fa-gamepad" />
              <h6 className="m-0">Gaming</h6>
            </div>
          </div>
          <div className="col-md-3 my-3">
            <div
              id="Others"
              className="card card-selector card-body text-center"
              onClick={this.cardSelect}
            >
              <i class="fa fa-ellipsis-h" />
              <h6 className="m-0">Others</h6>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
